import React from 'react';
import { Box, Typography, Paper, Container, Divider } from '@mui/material';
import MainLayout from '../../components/layout/MainLayout';

const AboutPage: React.FC = () => {
  return (
    <MainLayout>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center" color="primary" fontWeight="bold">
            About Us
          </Typography>
          
          <Divider sx={{ mb: 4, mt: 2 }} />
          
          <Box sx={{ my: 4 }}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.7 }}>
              MathWiz is a volunteer-driven math education league created for curious young minds ages 11 to 14. 
              Our mission is to make math exciting, meaningful, and accessible by helping students understand the 
              why behind each answer—not just the steps to get there. Through friendly competitions, skill-stretching 
              challenges, and opportunities to earn achievements and prizes, students explore new ways to think about 
              math while building confidence and having fun.
            </Typography>
            
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.7 }}>
              MathWiz was founded by longtime math educator Mr. T and a group of his former students, all inspired 
              by his 30-year legacy of making math feel fun, approachable, and empowering. What began as a local 
              program in Ohio is now growing across the U.S. and beyond, connecting students through a shared love 
              of learning and problem-solving. We're just getting started—and we're excited for what's ahead.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </MainLayout>
  );
};

export default AboutPage;